import { render, staticRenderFns } from "./AdminClientsPage.vue?vue&type=template&id=0b6246fd"
import script from "./AdminClientsPage.vue?vue&type=script&lang=js"
export * from "./AdminClientsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports